// removed by extract-text-webpack-plugin
module.exports = {"image-component":"image-component__image-component__3biel","changers":"image-component__changers__3Mbtl","bg-changer":"image-component__bg-changer__37t__","zoom-reset":"image-component__zoom-reset__13Ukd","drop-zone":"image-component__drop-zone__4IXDg","drop-zone-empty":"image-component__drop-zone-empty__3j_FI","drop-zone-completed":"image-component__drop-zone-completed__3lvBq","drop-zone-text":"image-component__drop-zone-text__1nwK0","image":"image-component__image__2zAzr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/image-component/image-component.scss
// module id = 38
// module chunks = 0